<template lang="pug">
	.plan-container
		.title.logo
			| Plan
		.title.overall-rating
			span.desktop Overall Rating
			span.mobile Rating
			icon-info.icon-info(:id="overallRatingId")
			b-tooltip(:target="overallRatingId" placement="top" triggers="click blur")
				.tooltip-info.small
					p
						| The 5-Cap Ratings represent our opinion of the attractiveness of each 529 plan, relative to all other 529 plans, based on the many factors that we feel are important.
					p
						a(:href="`${sfcUrl}/5-cap-ratings/ratings-criteria`" target="_blank") More info
		.title.performance
			| Performance
			icon-info.icon-info(:id="overallPerformaceId")
			b-tooltip(:target="overallPerformaceId" placement="top" triggers="click blur")
				.tooltip-info.small
					p
						| The performance score is derived from the analysis of performance as part of Savingforcollege.com’s 5-Cap Rating.
					p
						a(:href="`${sfcUrl}/5-cap-ratings/ratings-criteria`" target="_blank") More info
		.title.fee-score
			| Fee Score
			icon-info.icon-info(:id="overallFeesId")
			b-tooltip(:target="overallFeesId" placement="top" triggers="click blur")
				.tooltip-info.small
					p
						| The fee score is derived from the analysis of costs done as part of Savingforcollege.com's 5-Cap Rating. This analysis compares total average asset-based expenses of the plan to other 529 savings plans.
					p
						a(:href="`${sfcUrl}/5-cap-ratings/ratings-criteria`" target="_blank") More info
		.title.call-to-action
			| Get Started
</template>

<script>
import IconInfo from './icon-info'
import {track} from '../../track'
import {queryParams} from '../../query_params'
import CapRating from "./cap-rating";
import StarRating from "./star-rating";

export default {
	components: {
		IconInfo
	},
	data(){
		let stateRatingId = `state-rating-${Math.floor(Math.random()*1000000)}`
		let overallRatingId = `overall-rating-${Math.floor(Math.random()*1000000)}`
		let overallPerformaceId = `overall-performance-${Math.floor(Math.random()*1000000)}`
		let overallFeesId = `overall-fees-${Math.floor(Math.random()*1000000)}`
		return {
			stateRatingId,
			overallRatingId,
			overallPerformaceId,
			overallFeesId
		}
	}
}
</script>

<style lang="stylus" scoped>
	.plan-container
		display grid
		grid-template-columns 100px auto auto auto 130px
		height 30px
		border-top 1px solid #aebcca
		border-right 1px solid #aebcca
		border-left 1px solid #aebcca
		border-bottom 1px solid #aebcca
		@media (max-width: 529px)
			grid-template-columns 100px auto auto 130px
		@media (max-width: 455px)
			grid-template-columns 100px auto 130px
		@media (max-width: 354px)
			grid-template-columns 75px auto 130px

		.logo
		.overall-rating
		.performance
		.fee-score
		.call-to-action
			justify-self: center
			align-self: center
			font-size: 14px

		.fee-score
			@media (max-width: 529px)
				display none
		.performance
			@media (max-width: 455px)
				display none


		.icon-info
			cursor: pointer
			position relative
			top: -1px
			margin-left: 4px
			margin-right: 4px

		.title
			.mobile
				display none
			@media (max-width: 340px)
				.desktop
					display none
				.mobile
					display inline-block

		>>> .tooltip-info
			font-size 12px



</style>
